import ServiceDeskMyCity from './container'

export default ServiceDeskMyCity
